import React from 'react'
import { useIntl } from 'react-intl'

import { GlobalOutlined, DownOutlined } from '@ant-design/icons'
import { Dropdown, Button, Menu } from 'antd'
import PropTypes from 'prop-types'

const DesktopView = ({ value, onChange }) => {
  const intl = useIntl()

  const handleClick = ({ key }) => {
    onChange(key)
  }

  const menu = (
    <Menu
      selectable
      selectedKeys={[value]}
      onClick={handleClick}
      items={[
        {
          key: 'pt-BR',
          label: 'Português',
        },
        {
          key: 'en-US',
          label: 'English',
        },
        {
          key: 'es-ES',
          label: 'Español',
        },
      ]}
    />
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button
        block
        type="text"
        icon={<GlobalOutlined />}
        style={{
          width: '100%',
          textAlign: 'left',
          margin: 0,
          paddingLeft: 4,
          fontSize: 14,
        }}
      >
        {intl.formatMessage({
          id: 'global.labels.language',
        })}
        <span
          style={{
            float: 'right',
          }}
        >
          <DownOutlined style={{ fontSize: 10 }} />
        </span>
      </Button>
    </Dropdown>
  )
}

DesktopView.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default DesktopView
